import React from 'react';
import classnames from 'classnames';

import * as S from './Wrapper.module.css';
import * as T from './Wrapper.types';

export const Wrapper: React.FunctionComponent<T.IWrapperProps> = ({
  className,
  innerClassName,
  paddingVertical,
  paddingTop,
  paddingBottom,
  noPadding,
  children,
  bgColor,
}) => {
  const wrapInnerClass = classnames(
    S.wrapperInner,
    {
      [S.wrapperVerticalPadding]: paddingVertical,
      [S.wrapperTopPadding]: paddingTop,
      [S.wrapperBottomPadding]: paddingBottom,
      [S.wrapperNoPadding]: noPadding,
    },
    innerClassName
  );

  return (
    <div className={className} style={{ backgroundColor: bgColor }}>
      <div className={wrapInnerClass}>{children}</div>
    </div>
  );
};
